import React from 'react';

const Card = ({image, update, page, id}) =>{
    return(
        <div className={`card ${page}`} onClick={(event) => update(event)} id={id}>
            <img src={image} className="background" alt="product tab"/>
        </div>
    )
}

export default Card;